import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeadersDataInterface } from 'src/_lib/interfaces/header.interface';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { HeaderService } from 'src/_lib/service/header.service';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class HeaderLogoComponent {
  @Input() isMobile: boolean;
  domainName: string = environment.domainName;
  cdnImagePath: string = environment.cdnImagePath;
  imgBasePath: string = environment.imageBasePath;
  firstObj: number = this.appConstants.firstObj;
  storeImagePath: string = environment.storeImagePath;
  headerdata: HeadersDataInterface = {
    websiteHeader: [],
    firstRow: [],
    secondRow: [],
    thirdRow: []
  };

  constructor(private headerHttp: HeaderService,
    private appConstants: AppConstants,
    private dynamicThemeClassService: DynamicThemeClassService
  ) {}
  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }

  ngOnInit(): void {
    this.getheaderList();
  }

  onImageError(event: any) {
    event.target.src = `${this.imgBasePath}footer_logo.webp`;
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe(data => {
      this.headerdata = data[this.firstObj].data;
    });
  }
}